<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M2.667 6.4c0-.588.478-1.066 1.067-1.066h24.533a1.067 1.067 0 010 2.133H3.734c-.59 0-1.067-.477-1.067-1.066zM8 11.2c0-.588.478-1.066 1.067-1.066h19.2a1.067 1.067 0 010 2.133h-19.2c-.59 0-1.067-.477-1.067-1.066zm-4.266 3.734a1.067 1.067 0 100 2.133h24.533a1.067 1.067 0 100-2.133H3.734zM8 20.801c0-.59.478-1.067 1.067-1.067h19.2a1.067 1.067 0 010 2.133h-19.2c-.59 0-1.067-.477-1.067-1.066zm-4.266 3.733a1.067 1.067 0 100 2.133h24.533a1.067 1.067 0 000-2.133H3.734z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'editorTextAlignRight'
}
</script>
